import { IDocumentImage } from '@wix/client-search-sdk';

export const hasImage = (
  image: IDocumentImage,
): image is NonNullable<IDocumentImage> =>
  !!image && ('src' in image || 'name' in image);
